import { Capacitor } from "@capacitor/core";

const configuredServerUrl: unknown = import.meta.env["VITE_SERVER_URL"];
const configuredNativeServerUrl: unknown = import.meta.env["VITE_NATIVE_SERVER_URL"];

export const serverUrl =
  typeof configuredServerUrl === "string"
    ? configuredServerUrl
    : Capacitor.isNativePlatform()
      ? typeof configuredNativeServerUrl === "string"
        ? configuredNativeServerUrl
        : "https://pactfront.ugurakcay.com"
      : import.meta.env.PROD
        ? window.location.origin
        : "http://localhost:3001";
